// 196px * 2 - 16px padding -> 376px
export const newMessageButtonWidth = 132;
